import { useContext, useCallback, useMemo } from 'react';
import format from 'date-fns/format';
import TranslationContext, { dateFnsLocales } from './context';

export default function useTranslation(messagesFn) {
  const {
    getSingular,
    getPlural,
    setLanguage,
    language,
  } = useContext(TranslationContext);
  const storedLang = typeof window !== 'undefined' ? localStorage.getItem('translations') : null;

  const t = useCallback(
    (key) => {
      if (typeof messagesFn !== 'function') {
        console.warn('Translation messages function is not provided.');
        return key;
      }
      return messagesFn(getSingular, getPlural)(key);
    },
    [messagesFn, getSingular, getPlural]
  );

  const formatDate = useCallback(
    (date, formatString, options) => {
      const parsedDate = new Date(date);
      if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
        console.warn('Invalid date provided to formatDate:', date);
        return 'Invalid Date';
      }

      try {
        return format(parsedDate, formatString, {
          locale: dateFnsLocales[language] || undefined,
          ...options,
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Error';
      }
    },
    [language]
  );

  const lang = useMemo(() => language || storedLang || 'en', [language, storedLang]);

  return {
    t,
    lang,
    setLang: setLanguage,
    formatDate,
  };
};
